import { render } from "./CentroDeSaludComponent.vue?vue&type=template&id=a716434e&scoped=true"
const script = {}

import "./CentroDeSaludComponent.vue?vue&type=style&index=0&id=a716434e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a716434e"]])

export default __exports__